function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "options-sharp");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.856 4.689c-0.527-1.458-1.899-2.481-3.511-2.481s-2.983 1.023-3.502 2.455l-0.008 0.026h-18.835v2.483h18.834c0.527 1.458 1.899 2.481 3.511 2.481s2.983-1.023 3.502-2.455l0.008-0.026h6.421v-2.483z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.931 12.137c-1.611 0.002-2.983 1.025-3.503 2.457l-0.008 0.026h-6.42v2.483h6.42c0.527 1.458 1.899 2.481 3.511 2.481s2.983-1.023 3.502-2.455l0.008-0.026h18.835v-2.483h-18.834c-0.528-1.458-1.9-2.481-3.511-2.483h-0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.345 22.068c-1.611 0.002-2.983 1.025-3.503 2.457l-0.008 0.026h-18.834v2.483h18.834c0.527 1.458 1.899 2.481 3.511 2.481s2.983-1.023 3.502-2.455l0.008-0.026h6.421v-2.483h-6.42c-0.528-1.458-1.9-2.481-3.511-2.483h-0z"
});

var SvgOptionsSharp = function SvgOptionsSharp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOptionsSharp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/options-sharp.ba18d8dc.svg";
export { ForwardRef as ReactComponent };